import React, { Fragment } from "react";

class AppFooter extends React.Component {
  render() {
    return (
      <Fragment>
        <div className="app-footer">
          <div className="app-footer__inner">
            <div className="app-footer-left">
            </div>
            <div className="app-footer-right">
              <span>Copyright &copy; PICAdvanced {new Date().getFullYear()}</span>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/Layout/AppFooter/index.js